import {DbAttachment} from "../db/DbSchema";
import {DB} from "../db/DbManager";
import {EmailActions} from "./EmailActions";
import {PayloadAction} from "@reduxjs/toolkit";
import {AddRemoteOperationPayload} from "../redux/SyncSlice";

export class AttachmentActions {
    static async addAttachment(emailUid: string, file: File, attachment: DbAttachment): Promise<PayloadAction<AddRemoteOperationPayload>> {
        console.log(`Adding attachment: ${file.name} to email ${emailUid}`);

        await DB.saveEmailAttachment(attachment);

        await DB.saveEmailAttachmentData(attachment.attachmentUid, await file.arrayBuffer());

        return EmailActions.addRemoteOperation({
            AddAttachment: {
                EmailUid: emailUid,
                AttachmentUid: attachment.attachmentUid,
                Name: attachment.name,
                ContentId: attachment.contentId,
                File: file,
            }
        }, attachment);
    }

    static async renameAttachment(attachment: DbAttachment): Promise<PayloadAction<AddRemoteOperationPayload>> {
        console.log(`Renaming attachment - new name: ${attachment.name}`);

        await DB.saveEmailAttachment(attachment);

        return EmailActions.addRemoteOperation({
            RenameAttachment: {
                EmailUid: attachment.emailUid,
                AttachmentUid: attachment.attachmentUid,
                NewName: attachment.name
            }
        });
    }

    static async removeAttachment(emailUid: string, attachmentUid: string): Promise<PayloadAction<AddRemoteOperationPayload>> {

        await DB.deleteEmailAttachment(attachmentUid);

        await DB.deleteEmailAttachmentData(attachmentUid);

        return EmailActions.addRemoteOperation({
            RemoveAttachment: {
                EmailUid: emailUid,
                AttachmentUid: attachmentUid,
            }
        });
    }
}
